/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Overlap_LabelInputs */



/**
* | output |
* | --- |
* | "Overlap" |
*
* @param {Event_Warning_Overlap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_overlap_label = /** @type {((inputs?: Event_Warning_Overlap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Overlap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chevauchement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrapposizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перекрывать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Superposición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobreposição")
	return /** @type {LocalizedString} */ ("Overlap")
});